var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { LogLevel } from "@azure/msal-browser";
export function createMsalConfig(options) {
    return {
        auth: {
            clientId: options.clientId,
            authority: options.authority,
            redirectUri: options.redirectUri,
        },
        system: {
            loggerOptions: {
                loggerCallback: function (level, message, containsPii) {
                    if (containsPii) {
                        return;
                    }
                    if (level === LogLevel.Error) {
                        console.error("[MSAL] ".concat(message));
                    }
                    else if (level === LogLevel.Warning) {
                        //console.warn(`[MSAL] ${message}`);
                    }
                    else if (process.env.NODE_ENV !== "production") {
                        //console.log(`[MSAL] ${message}`);
                    }
                },
            },
        },
        cache: {
            cacheLocation: "sessionStorage",
        },
    };
}
export function createLoginRequest(apiScope, loginHint) {
    return __assign({ scopes: ["openid", "profile", "offline_access", apiScope].filter(Boolean) }, (loginHint ? { loginHint: loginHint } : {}));
}
export function createApiTokenRequest(apiScope) {
    return {
        scopes: [apiScope, "offline_access"].filter(Boolean),
    };
}
